<app-text-badge [type]="status.type">
	{{ status.text | translate }}
</app-text-badge>
